import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 3h3q -2.25 5 .75 11","key":"svg-0"}],["path",{"d":"M8 17a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-1"}],["path",{"d":"M12 17.01v.01","key":"svg-2"}]]

/**
 * IconSegway
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc2Vnd2F5Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMSAzaDNxIC0yLjI1IDUgLjc1IDExIiAvPgogIDxwYXRoIGQ9Ik04IDE3YTQgNCAwIDEgMCA4IDBhNCA0IDAgMSAwIC04IDAiIC8+CiAgPHBhdGggZD0iTTEyIDE3LjAxdi4wMSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/segway
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSegway = createReactComponent('outline', 'segway', 'Segway', __iconNode);

export default IconSegway;